import { action } from 'mobx';

import {
    QUERY_PARAM_KEY_REDIRECT_URL,
    QUERY_PARAM_KEY_SOCIAL_ACCESS_TOKEN
} from '~constants/Constants';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { UserRepository } from '~repositories/UserRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { StoreReceiptExtractedUseCase } from './StoreReceiptExtractedUseCase';

export class RampSignUpFormLoadedUseCase {
    private userRepository: UserRepository;
    private configRepository: ConfigRepository;

    constructor() {
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.configRepository = diContainer.get(serviceNames.configRepository);
    }

    @action
    public execute = async () => {
        const { userFormStore } = this.userRepository;
        const urlParams = new URLSearchParams(window.location.search);
        const accessToken = urlParams.get(QUERY_PARAM_KEY_SOCIAL_ACCESS_TOKEN);
        const redirectUrl = urlParams.get(QUERY_PARAM_KEY_REDIRECT_URL);

        new StoreReceiptExtractedUseCase().execute();

        if (accessToken) {
            userFormStore.setFieldValue('accessToken', accessToken);
        }

        if (redirectUrl) {
            this.configRepository.setRedirectUrlOverride(redirectUrl);
        }
    };
}
